// src/Components/NavBar.js
import { useState } from 'react';
import { Dialog } from '@headlessui/react';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';

const navigation = [
    { name: 'Why Us?', href: '/physiotherapy' },
    { name: 'Your Health', href: '/health' },
    { name: 'Services', href: '/services' },
    { name: 'Portfolio', href: '/portfolio' },
    { name: 'About', href: '/about' },
];

export default function Navbar() {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    return (
        <header className="absolute inset-x-0 top-0 z-50 bg-white/80 backdrop-blur-md shadow-sm">
            <div className="mx-auto max-w-7xl">
                <div className="px-6 pt-6 pb-6 lg:px-8">
                    <nav className="flex items-center justify-between" aria-label="Global">
                        <a href="/" className="-m-1.5 p-1.5 flex items-center space-x-2">
                            <img
                                alt="Anita.NG"
                                className="h-10 w-auto"
                                src="https://drive.google.com/uc?export=view&id=1BAWmb3MzFJ6S1CdRP8Vvi1H0wS2pTMRV&auto=format&fit=crop&w=1587&q=80"
                            />
                            <span className="text-xl font-bold text-gray-900">Anita.NG</span>
                        </a>
                        <button
                            type="button"
                            className="-m-2.5 rounded-md p-2.5 text-gray-700 lg:hidden"
                            onClick={() => setMobileMenuOpen(true)}
                        >
                            <span className="sr-only">Open main menu</span>
                            <Bars3Icon className="h-6 w-6" aria-hidden="true" />
                        </button>
                        <div className="hidden lg:flex lg:gap-x-12">
                            {navigation.map((item) => (
                                <a
                                    key={item.name}
                                    href={item.href}
                                    className="text-sm font-semibold leading-6 text-gray-900 hover:text-indigo-600 transition-colors duration-200"
                                >
                                    {item.name}
                                </a>
                            ))}
                        </div>
                    </nav>
                </div>
            </div>
            <Dialog as="div" className="lg:hidden" open={mobileMenuOpen} onClose={setMobileMenuOpen}>
                <div className="fixed inset-0 z-50" />
                <Dialog.Panel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
                    <div className="flex items-center justify-between">
                        <a href="/" className="-m-1.5 p-1.5 flex items-center space-x-2">
                            <img
                                className="h-8 w-auto"
                                src="https://drive.google.com/uc?export=view&id=1BAWmb3MzFJ6S1CdRP8Vvi1H0wS2pTMRV&auto=format&fit=crop&w=1587&q=80"
                                alt="Anita.NG"
                            />
                            <span className="text-lg font-bold text-gray-900">Anita.NG</span>
                        </a>
                        <button
                            type="button"
                            className="-m-2.5 rounded-md p-2.5 text-gray-700"
                            onClick={() => setMobileMenuOpen(false)}
                        >
                            <span className="sr-only">Close menu</span>
                            <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                        </button>
                    </div>
                    <div className="mt-6 flow-root">
                        <div className="-my-6 divide-y divide-gray-500/10">
                            <div className="space-y-2 py-6">
                                {navigation.map((item) => (
                                    <a
                                        key={item.name}
                                        href={item.href}
                                        className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                                    >
                                        {item.name}
                                    </a>
                                ))}
                            </div>
                        </div>
                    </div>
                </Dialog.Panel>
            </Dialog>
        </header>
    );
}